import { FC, Fragment } from 'react';
import { Link } from 'react-router-dom';
import 'twin.macro';
import 'styled-components/macro';

import { TextButton } from '../../atoms/button/Button';

export interface BreadCrumbsProps {
  crumbs: { label: string; path?: string }[];
}

export const BreadCrumbs: FC<BreadCrumbsProps> = ({ crumbs, ...props }) => (
  <div tw="flex items-center" {...props}>
    {crumbs.map(({ label, path }, index) => (
      <Fragment key={index}>
        {path ? (
          <Link to={path} tw="mr-1">
            <TextButton
              iconLeft="circle-arrow-left"
              tw="hover:opacity-80"
              css={{
                color: 'inherit',
                '&:hover': {
                  color: 'inherit',
                },
              }}
            >
              {label}
            </TextButton>
          </Link>
        ) : (
          <span tw="mr-1 font-normal truncate">{label}</span>
        )}
        {index < crumbs.length - 1 && <span tw="mr-1 font-normal">/</span>}
      </Fragment>
    ))}
  </div>
);
